import React from 'react';
import { Typography } from 'antd';

export default function Pedidolc(props) {
  const { Text } = Typography;
  const { parametros } = props;

  const textoOjo = () => {
    let string = '-';
    if (parametros.ojo === 'D') {
      string = 'OD';
    } else if (parametros.ojo === 'I') {
      string = 'OI';
    }
    return (<Text code>{string}</Text>);
  };

  const obtenerStringParametro = parametro => ((parametro !== null && parametro !== undefined && parametro !== '') ? parametro : '-');

  return (
    <div>
      <p>
        <span className="parametro-pedidoslc">{textoOjo()}</span>
        <span className="parametro-pedidoslc">
          Diametro:
          {obtenerStringParametro(parametros.diametro)}
        </span>
        {parametros.esfera
          && (
          <span className="parametro-pedidoslc">
            Esfera:
            {obtenerStringParametro(parametros.esfera)}
          </span>
          )
        }
        {parametros.eje
        && (
        <span className="parametro-pedidoslc">
          Eje:
          {obtenerStringParametro(parametros.eje)}
        </span>
        )
        }
        {parametros.cilindro
        && (
        <span className="parametro-pedidoslc">
          Cilindro:
          {obtenerStringParametro(parametros.cilindro)}
        </span>
        )
        }
        {parametros.radio
        && (
          <span className="parametro-pedidoslc">
          B. Curva:
            {obtenerStringParametro(parametros.radio)}
        </span>
        )
        }
        {parametros.dominancia
        && (
        <span className="parametro-pedidoslc">
          Dominancia:
          {obtenerStringParametro(parametros.dominancia)}
        </span>
        )}
      </p>
    </div>
  );
}
